import { isMobileDevice } from '../helpers';
import { colors, tourColors } from '../../global/variables';
import { toBounds } from './MapCalculations';


const { unusedMarkerStroke, routeGradientStart, routeGradientEnd, unselectedTourColor } = colors;

export const getMapSettings = () =>
  isMobileDevice()
    ? { paddingTopLeft: [50, 0], paddingBottomRight: [80, 0] }
    : { paddingTopLeft: [450, 100], paddingBottomRight: [40, 40] };

export const animateFlyTo = {
  animation: true,
  duration: 1.111,
  easeLinearity: 0.69,
};

export const normalizeBounds = (bounds, minimumDistanceKm = 100) => {
  if (!Array.isArray(bounds) || bounds.length !== 4 || bounds.some((value) => !Number.isFinite(value))) {
    return bounds;
  }

  const [west, south, east, north] = bounds;
  const latitude = (south + north) / 2;
  const minimumLatitudeSpan = minimumDistanceKm / 110.574;
  const minimumLongitudeSpan = minimumDistanceKm /
    (111.32 * Math.max(Math.cos((latitude * Math.PI) / 180), 0.01));
  const latitudeSpan = Math.max(north - south, minimumLatitudeSpan);
  const longitudeSpan = Math.max(east - west, minimumLongitudeSpan);
  const longitude = (west + east) / 2;

  return [
    longitude - longitudeSpan / 2,
    latitude - latitudeSpan / 2,
    longitude + longitudeSpan / 2,
    latitude + latitudeSpan / 2,
  ];
};

export const divideColors = (c1, c2, index, steps) => {
  if (!c1 || !c2 || !steps) return [];

  c1 = c1.match(/\d+/g).map(Number);
  c2 = c2.match(/\d+/g).map(Number);

  const colorArray = [];
  for (let i = 0; i < 3; i++) {
    colorArray[i] = Math.round(c1[i] + (index / steps) * (c2[i] - c1[i]));
  }

  return `rgb(${colorArray[0]},${colorArray[1]},${colorArray[2]})`;
};

export const getStyle = (feature, gradientRoutes, type, showOverlaps) => {
  const {
    properties: {
      routeId,
      mode,
      isStopsRequest,
      fromStop,
      totalStops,
      isUndesiredLine,
      colorGradient,
    },
  } = feature;

  const vehicleType = mode || type;
  const isPedestrian = vehicleType === 'pedestrian';
  const weight = 2;
  const dashArray = isPedestrian ? '2 6' : undefined;
  const color =
    isUndesiredLine && showOverlaps
      ? colorGradient
      : tourColors[routeId % tourColors.length].delivery.inner;
  const gradientColor = divideColors(routeGradientStart, routeGradientEnd, fromStop, totalStops);

  const routeColor = gradientRoutes && isStopsRequest ? gradientColor : color;

  return {
    opacity: 1,
    weight,
    color: routeColor,
    dashArray,
  };
};

export const getDelayColor = (duration, baseDuration) => {
  if (duration == null || baseDuration == null || baseDuration === 0) return null;
  const ratio = duration / baseDuration;
  if (ratio <= 1.03) return null;
  if (ratio <= 1.15) return '#FFD700';
  if (ratio <= 1.3) return '#FF8C00';
  return '#FF3B30';
};

export const getStyleUnselected = () => ({ opacity: 1, weight: 1.5, color: unselectedTourColor });
export const getStyleHidden = (feature, gradientRoutes, fleetType, showOverlaps) => {
  const base = getStyle(feature, gradientRoutes, fleetType, showOverlaps);
  return { ...base, opacity: 0.45, weight: 3, dashArray: '6 6' };
};
export const getStyleHitArea = () => ({ opacity: 0, weight: 20, fillOpacity: 0 });
export const getStyleOriginalLocationLine = () => ({
  opacity: 0.8,
  weight: 2,
  color: unusedMarkerStroke,
  dashArray: '4',
});
export const fitMapBounds = (map, bounds) => {
  if (!map) return;

  const latLngBoundsObj = toBounds(bounds);

  if (!latLngBoundsObj || !latLngBoundsObj.isValid()) {
    return;
  }

  map.fitBounds(latLngBoundsObj, getMapSettings(), animateFlyTo);
};
